// extracted by mini-css-extract-plugin
export default {"button":"button_button__TBeCs","primary":"button_primary__tjEAT","secondary":"button_secondary__hWo5n","icon":"button_icon__28sbQ"};